module.exports = __webpack_public_path__ + "img/genai2.37114428.png";